import { IDTO } from 'ts_utils';

export class UserDTO extends IDTO {
	public userId:number;
	public fbUserId:string;
	public displayName:string;
	public role:number;
	
	public override parse(json:any):void {
		if ("userId" in json) this.userId = json["userId"];
		if ("fbUserId" in json) this.fbUserId = json["fbUserId"];
		if ("displayName" in json) this.displayName = json["displayName"];
		if ("role" in json) this.role = json["role"];
	}
}

export class CreateUserDTO {
	public fbUserId:string;
	public displayName:string;
	public email:string;
	public role:number;
	
	public toForm():FormData {
		let fd = new FormData();
		if (this.fbUserId != null) fd.append("fbUserId", this.fbUserId);
		if (this.displayName != null) fd.append("displayName",
			this.displayName);
		if (this.email != null) fd.append("email", this.email);
		if (this.role != null) fd.append("role", this.role.toString());
		
		return fd;
	}
}

export class TeamDTO extends IDTO {
	public id:number;
	public name:string;
	public code:string;
	public size:number;
	public userId:number;
	
	public override parse(json:any):void {
		this.id = json["id"];
		this.name = json["name"];
		this.code = json["code"];
		this.size = json["size"];
		this.userId = json["userId"];
	}
}

export class TeamUploadDTO {
	public name:string;
	public code:string;
	public size:number;
	public userId:number;
	
	public toForm():FormData {
		let fd = new FormData();
		fd.append("name", this.name);
		fd.append("code", this.code);
		fd.append("size", this.size.toString());
		fd.append("userId", this.userId.toString());
		
		return fd;
	}
}

export class TeamUpdateDTO {
	public id:number;
	public size:number;
	
	public toForm():FormData {
		let fd = new FormData();
		fd.append("id", this.id.toString());
		fd.append("size", this.size.toString());
		
		return fd;
	}
}

export class ContestEntryDTO extends IDTO {
	public id:number;
	public dateString:string;
	public points:number;
	public teamId:number;
	public teamDto:TeamDTO;
	
	public override parse(json:any):void {
		this.id = json["id"];
		this.dateString = json["dateString"];
		this.points = json["points"];
		this.teamId = json["teamId"];
		this.teamDto = new TeamDTO();
		this.teamDto.parse(json["team"]);
	}
}

export class ContestEntryUpdateDTO {
	public dateString:string;
	public points:number;
	public teamId:number;
	
	public toForm():FormData {
		let fd = new FormData();
		fd.append("dateString", this.dateString);
		fd.append("points", this.points.toString());
		fd.append("teamId", this.teamId.toString());
		
		return fd;
	}
}